export { default as FavoritesLocation } from './FavoritesLocation';
